export default __webpack_public_path__ + "6b1f099eecee10492eed3230f84dad88.jpg";